import { FC } from 'react';
import { useField } from 'react-final-form';

import { FormCheckbox } from 'src/components/FormCheckbox/FormCheckbox';
import { FormTextArea } from 'src/components/FormTextArea/FormTextArea';
import { FormTextField } from 'src/components/FormTextField/FormTextField';
import { Section } from 'src/components/Section/Section';
import { FormTimezoneSelect } from 'src/components/TimezoneSelect/FormTimezoneSelect';

export const AdministratorTownFields: FC = () => {
  const enabled = useField<boolean>('enabled').input.value;

  return (
    <>
      <Section title='Укажите наименование' testId='administratorTownName'>
        <FormTextField
          name='name'
          size='medium'
          label='Наименование'
          dataTestId='administratorTownNameField'
          required
          fullWidth
        />
      </Section>
      <Section title='Укажите часовой пояс' testId='administratorTownTimezone'>
        <FormTimezoneSelect
          name='timeZone'
          dataTestId='administratorTownTimezoneField'
          required
        />
      </Section>
      <Section title='Выберите доступность' testId='administratorTownEnabled'>
        <FormCheckbox
          name='enabled'
          label='Доступно пользователям'
          dataTestId='administratorTownEnabledCheckbox'
        />
        <FormTextArea
          name='disabledReason'
          disabled={enabled}
          placeholder='Опишите причину недоступности'
          fullWidth
        />
      </Section>
      <Section title='Укажите атрибуты' testId='administratorAttributes'>
        <FormCheckbox
          name='isTestData'
          label='Для тестирования'
          dataTestId='administratorTownIsTestData'
        />
      </Section>
    </>
  );
};
